export default __webpack_public_path__ + "assets/images/listen-icon8-9dd05250.svg";